import React from 'react'
import { LoaderContainer } from './SummaryLoader.css'

interface SummaryLoaderProps {
  showLoader: boolean
}

export const SummaryLoader = ({
  showLoader,
}: SummaryLoaderProps) => {
  if (!showLoader) return null

  return <LoaderContainer />
}
